import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeCodeState } from '~/types';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

export type TypeRegisterContractUserInfoParams = {
  /** 주민등록번호 */
  juminNo: string;
  /** 주소 */
  address: string;
  /** 상세주소 */
  detailAddress: string;
  /** 은행 코드 */
  financialInstitution: string;
  /** 계좌 번호 */
  accountNo: string;
  /** 우편 번호 */
  postCode: string;
};

export type TypeRegisterContractUserInfoResponse = {
  code: number;
  message: string;
  data: {
    juminNo: string;
    maskedJuminNo: string;
    postCode: string;
    address: string;
    detailAddress: string;
    financialInstitution: TypeCodeState;
    accountNo: string;
    maskedAccountNo: string;
    accountName: string;
  };
};

/** @description 계약 체결 정보 등록 api 요청에 사용되는 커스텀 훅 */
export const useRegisterContractUserInfo = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeRegisterContractUserInfoParams) => {
      const endpoint = '/labor-accounts/privacy-info';
      return axiosInstance.put(endpoint, params);
    },
  });

  const requestRegisterContractUserInfo = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeRegisterContractUserInfoParams;
    onSuccess?: (res: TypeRegisterContractUserInfoResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestRegisterContractUserInfo;
};
